import { deleteCookie } from 'cookies-next';

const cookiesToRemove = [
  `sb-${process.env.NEXT_PUBLIC_SB_PROJECT_ID}-auth-token-code-verifier`,
  `sb-${process.env.NEXT_PUBLIC_SB_PROJECT_ID}-auth-token`
];

let cookieDomains: string[] = [];

cookieDomains = [
  'theurbandeveloper.com',
  '.theurbandeveloper.com',
  'www.theurbandeveloper.com',
  '.www.theurbandeveloper.com'
];

// Util function to remove cookies that were previously set using the full www.theurbandeveloper.com domain.
// Hopefully a temp solution that can be removed in the future.
// https://github.com/supabase/supabase/issues/27283#issuecomment-2170478242
const nukeCookies = () => {
  for (const cookie of cookiesToRemove) {
    // Just to be sure
    deleteCookie(cookie);

    // Clean up cookies for all domains
    for (const domain of cookieDomains) {
      // For chrome
      deleteCookie(cookie, { domain });
      // For firefox https://stackoverflow.com/a/67335269
      deleteCookie(cookie, { path: '/', domain });
    }
  }
};

export default nukeCookies;
